/** True when the visitor asked the OS for reduced motion. Safe where matchMedia is missing. */
export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false
  } catch {
    return false
  }
}
